<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Tip`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.0711 19.0711C17.2614 20.8807 14.7614 22 12 22C9.2386 22 6.7386 20.8807 4.92893 19.0711C3.11929 17.2614 2 14.7614 2 12C2 9.2386 3.11929 6.7386 4.92893 4.92893C6.7386 3.11929 9.2386 2 12 2C14.7614 2 17.2614 3.11929 19.0711 4.92893C20.8807 6.7386 22 9.2386 22 12C22 14.7614 20.8807 17.2614 19.0711 19.0711ZM12 6C12.5523 6 13 6.44772 13 7C13 7.55228 12.5523 8 12 8C11.4477 8 11 7.55228 11 7C11 6.44772 11.4477 6 12 6ZM12 9C12.5523 9 13 9.44772 13 10V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V10C11 9.44772 11.4477 9 12 9Z"/></svg>
</template>
<script>

export default {
  name: 'IconTip',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
